import AccountDetection from '../../../../banking/components/paycheck-routing/AccountDetection';

export default function PaycheckRoutingAccountDetection() {
    return <AccountDetection />;
}
